import { render, staticRenderFns } from "./PartnerDashboard.vue?vue&type=template&id=2f357937&scoped=true&"
import script from "./PartnerDashboard.vue?vue&type=script&lang=js&"
export * from "./PartnerDashboard.vue?vue&type=script&lang=js&"
import style0 from "./PartnerDashboard.vue?vue&type=style&index=0&id=2f357937&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f357937",
  null
  
)

export default component.exports